import React from "react";

const Gallery = () => {
  return (
    <div className="gallery-page container mt-5">
      <div className="row gap-4 text-center  mt-5">
        <div className="col">
          <img
            src="https://freight.cargo.site/w/666/q/94/i/f8a93f8ad4db2b345e880804ea0dc4a699aa047804ce21b7a8d439ccb3fd6ae4/Pettibon.png"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/700/q/75/i/2529d2bd8f94d880177781c432fb3b95921fd4d3abd596c83ac49beca8b1c3a1/Magid.jpg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/800/q/94/i/76c072c78fa68e67f7d7c30f878635732c9c7a533b4abc5ba6f0c08695f2d2e9/RS_7935.jpg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/691/q/94/i/b8ce3c25d0585141afac3984f2b1f193c7d0a21dbdda9d83c99aa5cd77a87ee8/1509563075-zw5yxdrw3cwu8f58krqo-xl.gif"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/1000/q/75/i/9f9a348f6ba3608b99298a258dea77558fa38bf3d3bf32200115f3b02934f219/Untitled.jpg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/821/q/94/i/16b6999761a98e8129827ea1c34b36610ff9b3e0f6c909771a339dd567ca3b61/kara-walker-canisters.jpg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/700/q/75/i/1a1a8ef85a9588c7349a4517064b6f863608ab0f816b2bba247023d157b36961/SOK-poster-low-res.jpg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
        <hr />
        <div className="col">
          <img
            src="https://freight.cargo.site/w/1000/q/75/i/d84fb650cbc906b06529e7fdd0cd4184a6e9219b10d17d8ace9133fc650753e1/IMG_0636.jpeg"
            alt="art_img"
          />
          <p className="mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem,
            sunt?
          </p>
          <p>1945</p>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
